import { Component, OnInit } from '@angular/core';
import { SeoSocialShareData, SeoSocialShareService } from 'ngx-seo';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.css']
})
export class NotFoundComponent implements OnInit {

  seoData: SeoSocialShareData = {
    title:  '404',
    description: 'The page you are searching does not exist or is deleted by the owner.',
    image: environment.url+'/assets/logo.png'
  };

  constructor( private seo: SeoSocialShareService) { }

  ngOnInit(): void {
    this.seo.setData(this.seoData)
  }

}
